<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row :gutters="15">
      <el-col :sm="12">
        <h4 class="form-title">Delivery Note</h4>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        :md="{ span: 12, offset: 12 }"
        :lg="{ span: 6, offset: 18 }"
        :sm="24"
        class="text-right"
      >
        <el-form ref="searchForm" @submit.native.prevent="fetch(1)">
          <el-form-item>
            <el-input
              type="text"
              v-model="pager.search_key"
              placeholder="Search..."
            >
              <el-button
                type="submit"
                slot="append"
                icon="el-icon-search"
                @click="fetch(1)"
              ></el-button
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="list.data" v-loading="isLoading">
          <el-table-column label="Description" min-width="110px">
            <template slot-scope="scope">
              <span>{{ scope.row.masterlist.description }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Part No." prop="masterlist.part">
          </el-table-column>
          <el-table-column label="ULD ID Code" prop="masterlist.uld_id_code">
          </el-table-column>
          <el-table-column
            label="Serial"
            prop="masterlist.tso_serial_no"
          ></el-table-column>
          <el-table-column label="Status" prop="status.name"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row justify="space-between" class="mt-2">
      <el-col :sm="12">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="fetch"
        >
        </el-pagination>
      </el-col>
      <el-col :sm="12" class="text-right">
        <el-button type="primary" size="small" @click="viewPDF">PDF</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ULD from "@/models/ULD";
import Masterlist from "@/models/Masterlist";
// import RepairStatus from "@/models/RepairStatus";
export default {
  name: "DeliveryReport",
  data: () => ({
    isLoading: false,
    list: { data: [], paging: {} },
    pager: { limit: 15, search_key: "" },
    descriptions: Masterlist.descriptions()
    // repairStatus: []
  }),
  methods: {
    fetch(page) {
      this.isLoading = true;
      this.pager.page = 1;
      if (page) {
        this.pager.page = page;
      }
      let params = {
        ...this.pager,
        is_report: 1
      };
      if (this.pager.search_key) {
        params.search_delivery = this.pager.search_key;
      }
      ULD.list(params).then(list => {
        this.list = list;
        this.isLoading = false;
      });
    },
    // getMasterlistDescription(masterlist) {
    //   let check = this.descriptions.find(
    //     o => o.value == masterlist.description
    //   );
    //   if (check) return check.text;
    //   else return "";
    // },
    viewPDF() {
      this.$router.push({ name: "deliveryReportPDF", query: this.pager });
    }
    // getStatusDescription(status_code) {

    // }
  },
  mounted() {
    // RepairStatus.list({ limit: 9999 }).then(data => {
    //   this.repairStatus = data.data;
    this.fetch(1);
    // });
  }
};
</script>

<style></style>
